import {Checkbox} from '@fluentui/react';
import React, {useMemo} from 'react';
import styled from 'styled-components';
import {getDisplayName} from '../../common/displayName';
import {ResourceDetails} from '../../types/ResourceDetails';
import {array} from '../../util';
import {ItemTags} from './ItemTags';
import {textColor} from '../../styles';

type Props = {
  checked: boolean;
  item: ResourceDetails;
  onCheck: (checked: boolean) => void;
  size: number;
  nameFieldId?: string;
};

export function Item(props: Props): JSX.Element | null {
  const styles = useMemo(() => {
    return makeStyles(props.size);
  }, [props.size]);

  const textStyle = useMemo(() => {
    return makeTextStyle(props.size);
  }, [props.size]);

  const name = getDisplayName(props.item, props.nameFieldId);
  const tags = getTags(props.item);

  return (
    <Container>
      <Checkbox
        checked={props.checked}
        onChange={(_, checked) => props.onCheck(checked ?? false)}
        onRenderLabel={() => (
          <CheckboxLabel>
            <span style={textStyle}>{name}</span>
            <ItemTags tags={tags} size={props.size} />
          </CheckboxLabel>
        )}
        styles={styles}
      />
    </Container>
  );
}

function makeStyles(size: number) {
  return {
    root: {},
    label: {
      alignItems: 'center',
    },
    checkbox: {
      width: size + 'px',
      height: size + 'px',
    },
  };
}

function makeTextStyle(size: number) {
  return {
    fontSize: size + 'px',
    lineHeight: size * 1.5 + 'px',
    color: textColor,
  };
}

function getTags(item: ResourceDetails): string[] {
  return array(item.__tag__) || [];
}

export type isChecked = (id: string) => boolean;

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const CheckboxLabel = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-left: 0.5rem;
`;
